import { render, staticRenderFns } from "./TabPageSet.vue?vue&type=template&id=8f680c7a&scoped=true&"
import script from "./TabPageSet.vue?vue&type=script&lang=js&"
export * from "./TabPageSet.vue?vue&type=script&lang=js&"
import style0 from "./TabPageSet.vue?vue&type=style&index=0&id=8f680c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f680c7a",
  null
  
)

component.options.__file = "TabPageSet.vue"
export default component.exports